import { api, buildStorefrontApiPath } from "@/lib/api";

// Sprint 12 Slice 2 — Wholesale request flow (storefront customer side).

export type CustomerTier = "RETAIL" | "WHOLESALE";
export type TierRequestStatus = "PENDING" | "APPROVED" | "REJECTED";

export interface TierRequestRecord {
  id: string;
  status: TierRequestStatus;
  requestedTier: CustomerTier;
  note: string | null;
  reviewNote: string | null;
  reviewedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TierRequestStatusPayload {
  wholesaleEnabled: boolean;
  currentTier: CustomerTier;
  latestRequest: TierRequestRecord | null;
  canRequest: boolean;
}

function unwrap<T>(input: unknown): T {
  const payload = input as { data?: T } | T;
  return ((payload as { data?: T })?.data ?? payload) as T;
}

export async function getTierRequestStatus(): Promise<TierRequestStatusPayload> {
  const res = await api.get(buildStorefrontApiPath("/me/tier-request"));
  return unwrap<TierRequestStatusPayload>(res.data);
}

export async function submitTierRequest(input: {
  note?: string;
}): Promise<TierRequestRecord> {
  const trimmedNote = input.note?.trim();
  const body = trimmedNote ? { note: trimmedNote } : {};
  const res = await api.post(buildStorefrontApiPath("/me/tier-request"), body);
  return unwrap<TierRequestRecord>(res.data);
}
